import moment from 'moment-timezone';
import {i18n} from 'src/i18n';
import layoutActions from 'src/modules/layout/layoutActions';
import PlanificadorTareaCustomService from 'src/modules/planificadorTareaCustom/planificadorTareaCustomService';
import Errors from 'src/modules/shared/error/errors';
import {getHistory} from 'src/modules/history';
import Message from 'src/view/shared/message';

const prefix = 'PLANIFICADORTAREACUSTOM_FORM';

const planificadorTareaCustomFormActions = {
  INIT_STARTED: `${prefix}_INIT_STARTED`,
  INIT_SUCCESS: `${prefix}_INIT_SUCCESS`,
  INIT_ERROR: `${prefix}_INIT_ERROR`,

  CREATE_STARTED: `${prefix}_CREATE_STARTED`,
  CREATE_SUCCESS: `${prefix}_CREATE_SUCCESS`,
  CREATE_ERROR: `${prefix}_CREATE_ERROR`,

  UPDATE_STARTED: `${prefix}_UPDATE_STARTED`,
  UPDATE_SUCCESS: `${prefix}_UPDATE_SUCCESS`,
  UPDATE_ERROR: `${prefix}_UPDATE_ERROR`,

  doInit: (id) => async (dispatch) => {
    try {
      dispatch({
        type: planificadorTareaCustomFormActions.INIT_STARTED,
      });

      let record = {};

      const isEdit = Boolean(id);

      if (isEdit) {
        record = await PlanificadorTareaCustomService.find(id);
      }

      dispatch({
        type: planificadorTareaCustomFormActions.INIT_SUCCESS,
        payload: record,
      });
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: planificadorTareaCustomFormActions.INIT_ERROR,
      });

      getHistory().push('/planificacion');
    }
  },

  doCreate: (values) => async (dispatch) => {
    try {
      dispatch({
        type: planificadorTareaCustomFormActions.CREATE_STARTED,
      });

      await PlanificadorTareaCustomService.create(values);

      dispatch({
        type: planificadorTareaCustomFormActions.CREATE_SUCCESS,
      });

      Message.success(i18n('entities.planificadorTareaCustom.create.success'));

      // dispatch(listActions.doFetchCurrentFilter());

      // getHistory().push('/planificacion');

      dispatch(
        layoutActions.doVisibleDrawer({
          drawerId: 'DrawerPlanificadorTareaCustomFormPage',
          drawerVisible: false,
          drawerChanged: moment().unix(),
          drawerUpdateComponent: 'PlanificadorTareaCustomListFilter',
        }),
      );

      if (values.estado === 'Enviada') {
        dispatch(
          layoutActions.doVisibleDrawer({
            drawerId: 'DrawerModeloTareaListPage',
            drawerVisible: false,
            drawerChanged: moment().unix(),
            drawerUpdateComponent: null,
          }),
        );
      }
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: planificadorTareaCustomFormActions.CREATE_ERROR,
      });
    }
  },

  doUpdate: (id, values) => async (dispatch, getState) => {
    try {
      dispatch({
        type: planificadorTareaCustomFormActions.UPDATE_STARTED,
      });

      await PlanificadorTareaCustomService.update(id, values);

      dispatch({
        type: planificadorTareaCustomFormActions.UPDATE_SUCCESS,
      });

      Message.success(i18n('entities.planificadorTareaCustom.update.success'));

      // dispatch(listActions.doFetchCurrentFilter());

      // getHistory().push('/planificacion');

      dispatch(
        layoutActions.doVisibleDrawer({
          drawerId: 'DrawerPlanificadorTareaCustomFormPage',
          drawerVisible: false,
          drawerChanged: moment().unix(),
          drawerUpdateComponent: 'PlanificadorTareaCustomListFilter',
        }),
      );
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: planificadorTareaCustomFormActions.UPDATE_ERROR,
      });
    }
  },
};

export default planificadorTareaCustomFormActions;
